import { Alert, Button, Flex, Typography } from 'antd'
import React from 'react'
import { IntercomClient } from '~/plugins/intercom/client'

type Props = {
  onClose: () => void
}

export const ErrorAlert: React.FC<Props> = ({ onClose }) => {
  const { show } = IntercomClient.use()

  const onClick = () => {
    show()
  }

  return (
    <>
      <div className="p-4">
        <Alert
          type="error"
          showIcon
          closable
          onClose={onClose}
          message={
            <Flex vertical>
              <Typography.Text type="danger">
                Something went wrong while generating the response.
              </Typography.Text>

              <Typography.Text type="danger">
                If this issue persist,{' '}
                <u onClick={onClick} style={{ cursor: 'pointer' }}>
                  contact us
                </u>
                .
              </Typography.Text>

              <div>
                <Button onClick={onClose}>Retry</Button>
              </div>
            </Flex>
          }
        />
      </div>
    </>
  )
}
